import * as React from 'react'
import { Avatar, Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import NextLink from 'next/link'

type Props = {
  user: {
    id?: string
    displayName: string
    accountId?: string
    avatar?: { uri: string }
  }
  artist?: boolean
}

const Component: React.FC<Props> = function ({ user, artist = false }) {
  const s = useStyle({})

  if (!user)
    return (
      <div>
        <Avatar src={null} />
      </div>
    )

  return (
    <NextLink
      as={artist ? `/artists/${user.accountId}` : `/users/${user.id}`}
      href={artist ? '/artists/[name]' : '/users/[id]'}
      passHref
    >
      <Link href="#">
        <div className={s.content}>
          <Avatar src={user.avatar?.uri} />
          <span className={s.name}>{user.displayName}</span>
        </div>
      </Link>
    </NextLink>
  )
}

export default Component

const useStyle = makeStyles({
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  name: {
    paddingLeft: 5,
  },
})
